export default "__VITE_ASSET__gLps$oxU__"